import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FilledLoading from "../loader/FilledLoading";
import { getInvitationDetails } from "../../../store/reducers/invitationReducer";
import { editArrival } from "../../../store/reducers/guestsReducer";
import { InvDiv, FlexRowBetween, GenericDiv, Input } from "../Style";
import { addAlpha } from "../others/Functions";
import Output from "./Output";
import Names from "./Names";
import Links from "./Links";
import Footer from "./Footer";
import Extra from "./Extra";
import { handleClickScroll } from "../others/Functions";

/**
 * Invitation33 – גרסה מפושטת של דף ההזמנה.
 * רק שני כפתורים: מגיע/ה (שליחה מיידית עם accept: 1) ולא מגיע/ה (accept: 0).
 * ללא כפתור "שליחה" – הלחיצה על הכפתור שולחת ישירות לשרת.
 */
const Invitation33 = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { token } = useParams();
  const search = useLocation().search;

  const getId = (num) => {
    let name = new URLSearchParams(search).get("n");
    name = window.atob(name);
    name = name.split(" ");
    return name[num];
  };

  useEffect(() => {
    setLoading(true);
    dispatch(getInvitationDetails({ token })).then((res) => {
      setLoading(false);
      if (res.payload?.error) toast.error("חלה שגיאה, יש לנסות לרענן...");
      else setDetails(res.payload);
    });
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("bla");
    }, 2000);
  }, []);

  const borderedInvsStyle = {
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.75)",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    padding: "6px",
    borderRadius: "16px",
    paddingBottom: "24px",
    border: "1px solid rgba(0,0,0,0.06)",
  };
  const basicDivStyle =
    details?.invK === 1 ? { width: "100%" } : borderedInvsStyle;

  return (
    <>
      {details ? (
        <InvDiv
          gradient={details.gradient}
          style={{
            width: "100%",
            height: `${window.screen.availHeight}px`,
            height: "100%",
            padding: details.invK === 1 ? "0" : "15px",
            position: "relative",
          }}
        >
          <div style={{ ...basicDivStyle }}>
            <Output
              _id={details._id}
              pic={details.pic}
              picPosition={details.picPosition}
              cropAreaAspect={details.cropAreaAspect}
            />
            <Names data={details} heartColor={details.heartColor} />
            <ArrivalTwoButtons
              token={token}
              heartColor={details.heartColor}
              specialDishes={details.specialDishes}
              self={false}
            />
            {details.inv === 1 && <Extra data={details} />}
            {/* <Links data={details} /> */}
          </div>
          <Footer producer={details.producer} />
          {loading && <FilledLoading />}
        </InvDiv>
      ) : (
        <FilledLoading />
      )}
    </>
  );
};

/**
 * בלוק אישור הגעה עם שני כפתורים בלבד: מגיע/ה (1) ולא מגיע/ה (0).
 * שליחה מיידית לשרת בלי כפתור "שליחה" נפרד.
 */
const ArrivalTwoButtons = ({ token, heartColor, specialDishes, self }) => {
  const dispatch = useDispatch();
  const [selfFullname, setFullname] = useState("");
  const [selfPhone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const buildBody = (accept) => {
    const acceptWomen = accept === 0 ? 0 : null;
    const acceptMen = accept === 0 ? 0 : null;
    const body = {
      accept: accept === 0 ? 0 : 1,
      acceptWomen,
      acceptMen,
      ans: self ? "S" : "L",
      notes: "",
      selfFullname,
      selfPhone,
      self,
    };
    if (specialDishes) {
      body.dishes = [0, 0, 0, 0];
    }
    return body;
  };

  const validateSelf = () => {
    let phone1 = selfPhone;
    if (phone1[0] === "0") phone1 = phone1.substring(1);
    phone1 = phone1.replaceAll("-", "").replaceAll(/[^\d]/g, "");
    const regex = /^[5]{1}[0-9]{8}$/g;
    const valid = regex.test(phone1);
    if (selfFullname.length < 2 || selfFullname.length > 30 || !valid) {
      toast.warning("נא למלא שם מלא (2-30 תווים) ומספר נייד ישראלי חוקי");
      return false;
    }
    return true;
  };

  const send = (accept) => {
    if (self && !validateSelf()) return;
    setLoading(true);
    dispatch(editArrival(token, buildBody(accept))).then((res) => {
      setLoading(false);
      if (!res.payload?.error) {
        toast.success("תודה רבה על תשובתך!");
        setDone(true);
      } else {
        toast.error(res.payload?.error);
      }
    });
  };

  if (done) {
    return (
      <GenericDiv
        onClick={() => setDone(false)}
        style={{
          padding: "12px 40px",
          borderRadius: "999px",
          boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
          color: "white",
          fontWeight: "700",
          fontSize: "15px",
          background: heartColor,
          width: "min-content",
          margin: "0 auto",
          marginTop: "18px",
          cursor: "pointer",
          transition: "box-shadow 0.2s ease",
        }}
      >
        שליחה מחדש
      </GenericDiv>
    );
  }

  return (
    <>
      {self ? (
        <FlexRowBetween
          style={{
            width: "90%",
            margin: "0px auto",
            marginTop: "20px",
            background: `${addAlpha(heartColor, 0.3)}`,
            padding: "20px",
            borderRadius: "12px",
            gap: "12px",
          }}
        >
          <div style={{ position: "relative", width: "50%" }}>
            <Input
              value={selfFullname}
              style={{
                padding: "12px 14px",
                paddingRight: "14px",
                borderRadius: "10px",
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                background: "rgba(255,255,255,0.9)",
                fontSize: "15px",
                direction: "rtl",
                transition: "border-color 0.2s ease, box-shadow 0.2s ease",
              }}
              placeholder={"שם מלא"}
              onChange={(e) => setFullname(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = heartColor;
                e.target.style.boxShadow = `0 0 0 2px ${addAlpha(heartColor, 0.25)}`;
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(0,0,0,0.08)";
                e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
              }}
            />
          </div>
          <div style={{ position: "relative", width: "40%" }}>
            <Input
              value={selfPhone}
              type="tel"
              inputMode="numeric"
              style={{
                padding: "12px 14px",
                paddingRight: "14px",
                borderRadius: "10px",
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                background: "rgba(255,255,255,0.9)",
                fontSize: "15px",
                direction: "rtl",
                transition: "border-color 0.2s ease, box-shadow 0.2s ease",
              }}
              placeholder={"מס׳ נייד"}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={(e) => {
                e.target.style.borderColor = heartColor;
                e.target.style.boxShadow = `0 0 0 2px ${addAlpha(heartColor, 0.25)}`;
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "rgba(0,0,0,0.08)";
                e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
              }}
            />
          </div>
        </FlexRowBetween>
      ) : null}

      <FlexRowBetween
        id="bla"
        style={{
          justifyContent: "center",
          gap: "16px",
          marginTop: "20px",
          padding: "0 20px",
          flexWrap: "wrap",
        }}
      >
        <GenericDiv
          onClick={() => send(1)}
          style={{
            padding: "14px 32px",
            borderRadius: "999px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
            color: "white",
            fontWeight: "700",
            fontSize: "16px",
            background: heartColor,
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
            transition: "box-shadow 0.2s ease, transform 0.2s ease",
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.2)";
              e.currentTarget.style.transform = "scale(1.02)";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.15)";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          מגיע/ה
        </GenericDiv>
        <GenericDiv
          onClick={() => send(0)}
          style={{
            padding: "14px 32px",
            borderRadius: "999px",
            boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
            color: "white",
            fontWeight: "700",
            fontSize: "16px",
            background: "rgba(100,100,100,0.85)",
            border: "none",
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
            transition: "box-shadow 0.2s ease, transform 0.2s ease",
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.2)";
              e.currentTarget.style.transform = "scale(1.02)";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 14px rgba(0,0,0,0.12)";
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          לא מגיע/ה
        </GenericDiv>
      </FlexRowBetween>

      {loading && <FilledLoading />}
    </>
  );
};

export default Invitation33;
